<ng-container [ngSwitch]="processKind$ | async">
  <app-form-travel-in-pl *ngSwitchCase="processKinds.TRAVELINPL"></app-form-travel-in-pl>
  <app-form-trip-abroad *ngSwitchCase="processKinds.TRIPABROAD"></app-form-trip-abroad>
  <app-form-resignation *ngSwitchCase="processKinds.RESIGNATION"></app-form-resignation>
  <app-error *ngSwitchDefault />
</ng-container>
